import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpService } from './HttpService';
import { RequestOptions } from '../model/RequestOptions';
import { ConfigSettingDto } from '../model/business/ConfigSettingDto';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class ConfigApiService {
  constructor(
    private httpService: HttpService,
  ) {}

  saveConfigSettings(configSettingDto: ConfigSettingDto): Observable<any> {
    const requestOptions = new RequestOptions();
    requestOptions.ShowLoader = true;
    requestOptions.ShowSuccess = true;
    requestOptions.HandleGenericError = true;
    return this.httpService.post<any>(
      'configSetting/saveConfigSettings',
      configSettingDto,
      null,
      requestOptions
    );
  }

  getConfigSettings(intermediaryId: string, productType: string): Observable<ConfigSettingDto> {
    return this.httpService.get<ConfigSettingDto>(
      'configSetting/getConfigSettings',
      {
        intermediary_id: intermediaryId,
        productType,
      },
      null
    );
  }
}
